module.exports = __webpack_public_path__ + "static/desktop/img/photobook-2.a3296192.png";